import { configureStore } from "@reduxjs/toolkit";
import { userList } from "./features/user/userSlice";
import logger from "redux-logger";
import {sharedSlice} from "./features/shared/sharedSlice"
import { newsLetterList } from "./features/news-letter/newsLetterSlice";
import { planList } from "./features/plan/planSlice";
import { subscriptionList } from "./features/subscription/subscriptionSlice";
import { contactList } from "./features/contact/contactSlice";
import { videoList } from "./features/videos/videoSlice";
import { productList } from "./features/products/productSlice";
import { settingsList } from "./features/settings/settingsSlice";
import { dasboardSlice } from "./features/dashboard/dashboardSlice";
import { logoList } from "./features/partner-logos/partnerSlice";

export const store = configureStore({
  reducer: {
    userList: userList.reducer,
    sharedActions: sharedSlice.reducer,
    newsLetterList: newsLetterList.reducer,
    planList: planList.reducer,
    subscriptionList: subscriptionList.reducer,
    contactList: contactList.reducer,
    videoList: videoList.reducer,
    productList: productList.reducer,
    settingsList:settingsList.reducer,
    dashboard: dasboardSlice.reducer,
    logoList: logoList.reducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST"],
      },
    })
      .concat(logger as any)
});


export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
